import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { updateMode } from "../../actions/mode";
import { setFilesReadyToProcess } from "../../actions/file";
import { getLink } from "../../dataProvider/links.js";
import UploadFileTableElement from "./UploadFileTableElement";
import useWindowDimensions from "../util/Window";
import { Modal } from "react-bootstrap";

import downloadButton from "../../img/v2/home/upload/download-button.png";

import { UploadValidation } from "../util/Svg.jsx";
import LoadingArrowIcon from "../../img/v1/upload/loading-arrows.svg";
import LoadingIconV2 from "../../img/v2/upload/loading.png";

import "../../scss/v2/upload.scss"

function UploadFileTable(props) {
  const { width } = useWindowDimensions();

  const { t, i18n } = useTranslation();
  const [error, setError] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [displayModalMode, setDisplayModalMode] = useState("start");
  const [product, setProduct] = useState({});
  let navigate = useNavigate();

  useEffect(() => {
    if (props.products[0] && !product.id) setProduct(props.products[0]);
  }, [props.products, product.id]);

  useEffect(() => {
    const interval = setInterval(() => {
      let adjustedStep = 5;
      if (
        progress === 45 ||
        progress === 55 ||
        progress === 75 ||
        progress === 90
      ) {
        adjustedStep = 1;
      } else if (progress % 5 !== 0) {
        adjustedStep = 1;
      }
      return setProgress(progress + adjustedStep);
    }, 250);
    if (progress >= 110) setDisplayModalMode("end");
    if (progress >= 160) clearInterval(interval);

    return () => clearInterval(interval);
  }, [progress]);

  const redirectToPayment = () => {
    navigate(getLink("payment1", i18n.language));
  };

  const redirectPayment = () => {
    setButtonLoading(true);

    if (!props.compress && !props.split && props.file.files.find((file) => file.mode === "convert" && !file.convertTo)
    ) {
      setButtonLoading(false);
      return setError("file");
    }    

    if (props.user.user?.id) {
      setButtonLoading(false);
      if(!props.user.subscription.subscribed) return navigate(getLink("manageAccount", i18n.language));
      props.dispatch(setFilesReadyToProcess());
      return navigate(getLink("cloud", i18n.language));
    }

    props.dispatch(updateMode(props.compress ? "compress" : props.split ? "split" : "convert"));
    props.dispatch(setFilesReadyToProcess());
    setButtonLoading(false);
    if (!props.compress && !props.split) {
      //start modal animation
      setDisplayModal(true);
      setDisplayModalMode("start");
      setProgress(0);
      //send to payment after the animation
      setTimeout(function () {
        redirectToPayment();
      }, 12000);
    } else {
      redirectToPayment();
    }
  };

  const renderHead = () => {
    return (
      <tr>
        <th>{t("homepage.uploadTable.title.name")}</th>
        <th>{t(`homepage.uploadTable.title.${props.compress ? "compress" : props.split ? "split" : "convert"}`)}
        </th>
        <th></th>
      </tr>
    );
  };

  function renderButton() {
    if (buttonLoading)
      return (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    return (
      <button className="button orange-button download-button" onClick={redirectPayment}>
        <img className="img img-fluid download-button-icon" src={downloadButton} alt={downloadButton} />
        {t(`homepage.uploadTable.redirect.button${props.split ? "Split" : ""}`)}
      </button>
    );
  }

  function renderError() {
    if (!error) return null;
    return (<div className="alert alert-danger">{t(`homepage.uploadTable.error.${error}`)}</div>);
  }

  if (!props.file.files || props.file.files.length === 0) return null;
  const displayableFiles = [];
  props.file.files.forEach((el, index) => {
    el.index = index;
    if (props.compress) {
      if (el.mode === "compress") displayableFiles.push(el);
    } else if (props.split) {
      if (el.mode === "split") displayableFiles.push(el);
    } else {
      if (el.mode === "convert") displayableFiles.push(el);
    }
  });

  if (displayableFiles.length === 0) return null;

  return (
    <div className="uploaded-file-container">
      { renderError() }
      { width >= 768 ? (
        <div className="table-responsive-sm">
        <table className="table uploaded-file-table">
          <thead>{renderHead()}</thead>
          <tbody>
            {displayableFiles.map((file, index) => (
              <UploadFileTableElement
                key={index}
                index={index}
                updateIndex={file.index}
                displayedFile={file}
                error={error}
                compress={props.compress}
                split={props.split}
              />
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3} className={"download-button-container-no-email"}>{renderButton()}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      ) : (
        <div className="mobile-file-table">
          <div className="mobile-file-row-container">
            {displayableFiles.map((file, index) => (
                    <UploadFileTableElement
                      key={index}
                      index={index}
                      updateIndex={file.index}
                      displayedFile={file}
                      error={error}
                      compress={props.compress}
                      split={props.split}
                    />
              ))}
          </div>
          {renderButton()}
      </div>
      ) }
      {displayModal && (
        <Modal id="loader-modal" show={true} onHide={() => { return; }}>
          <Modal.Body>
            {displayModalMode === "start" ? (
              <>
                <div className="icon-container">
                  <img className="img img-fluid loading-icon" src={LoadingIconV2} alt={LoadingIconV2} />
                  <div className="loading-arrow-icon-container">
                    <img className="img img-fluid loading-arrow-icon" src={LoadingArrowIcon} alt={LoadingArrowIcon} />
                  </div>
                </div>
                {displayableFiles.length > 1 ? (
                  <h2 className="loading-modal-title">
                    {t("homepage.uploadTable.loadingModal.titleMultiple")}
                  </h2>
                ) : (
                  <h2 className="loading-modal-title">
                    {t("homepage.uploadTable.loadingModal.title")
                      .replace("<input>", displayableFiles[0].name.split(".")[displayableFiles[0].name.split(".").length - 1].toUpperCase())
                      .replace("<output>", displayableFiles[0].convertTo.toUpperCase())}
                  </h2>
                )}
                <div className="progress position-relative">
                  <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" />
                  <small className="progress-text justify-content-center d-flex position-absolute w-100">
                    {t(`homepage.uploadTable.progress${props.compress ? "Compress" : ""}`)}
                  </small>
                </div>
                <p className="loading-modal-text">{t("homepage.uploadTable.loadingModal.text")}</p>
                <p className="loading-modal-text font-italic mt-2" dangerouslySetInnerHTML={{ __html: t("homepage.uploadTable.loadingModal.disclaimer", { acqPrice: product.acqPrice, subPrice: product.subPrice }) }} />
              </>
            ) : (
              <>
                <div className="icon-container validation-icon">
                  <UploadValidation />
                </div>
                {displayableFiles.length > 1 ? (
                  <h2 className="loading-modal-title">{t("homepage.uploadTable.loadingModal.titleFinishedMultiple")}</h2>
                ) : (<h2 className="loading-modal-title">{t("homepage.uploadTable.loadingModal.titleFinished")}</h2>)}
                <div className="progress position-relative fade-out-disappear">
                  <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" />
                  <small className="progress-text justify-content-center d-flex position-absolute w-100">
                    {t(`homepage.uploadTable.progress${props.compress ? "Compress" : ""}`)}
                  </small>
                </div>
                <p className="loading-modal-text fade-out-disappear">
                  {t("homepage.uploadTable.loadingModal.text")}
                </p>
                <p className="loading-modal-text font-italic mt-2 fade-out-disappear" dangerouslySetInnerHTML={{ __html: t("homepage.uploadTable.loadingModal.disclaimer", { acqPrice: product.acqPrice, subPrice: product.subPrice }) }} />
              </>
            )}
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  file: state.file,
  user: state.user,
  products: state.product.products,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(UploadFileTable);
